// test260
(260 && 0);
